module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg1.1e7edefc.png";